import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Grid, IconButton, TextField } from '@mui/material'
import { useAuth, useLanguage, useReportsContext } from '../../context'
import { useStatus } from '../../context/Status.context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import ChangePasswordDialog from '../../dialogs/ChangePasswordDialog'
import RequestPasswordResetDialog from '../../dialogs/RequestPasswordResetDialog'

const Login = () => {
    const { dictionary } = useLanguage()
    const { login } = useAuth()
    const { setstatus } = useStatus()
    const { initiateEndAllShifts } = useReportsContext()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const navigate = useNavigate()
    const location = useLocation()
    const [verPassword, setVerPassword] = useState('password')

    // Estados para el cambio de contraseña
    const [showChangePassword, setShowChangePassword] = useState(false)
    const [changePasswordData, setChangePasswordData] = useState(null)
    const [showRequestReset, setShowRequestReset] = useState(false)

    const cambiarVistaPassword = () => {
        if (verPassword === 'password') {
            setVerPassword('text')
        } else {
            setVerPassword('password')
        }
    }

    const handleChange = (event) => {
        switch (event?.target?.name) {
        case 'username': {
            const inputValue = event.target.value
            if (inputValue.includes('@')) {
                setUsername(inputValue)
            } else {
                const onlyRUTChars = inputValue.replace(/[^0-9kK]/g, '')
                const isPureRUTInput = inputValue.length > 0 &&
                        (onlyRUTChars.length === inputValue.replace(/-/g, '').length)

                if (isPureRUTInput) {
                    let formattedRut = ''
                    const maxRutLengthBeforeVerification = 8
                    const maxTotalRutChars = maxRutLengthBeforeVerification + 1

                    let processedRutChars = onlyRUTChars

                    if (processedRutChars.length > maxTotalRutChars) {
                        processedRutChars = processedRutChars.substring(0, maxTotalRutChars)
                    }

                    if (processedRutChars.length > 1) {
                        formattedRut = processedRutChars.slice(0, -1) + '-' + processedRutChars.slice(-1).toUpperCase()
                    } else {
                        formattedRut = processedRutChars
                    }
                    setUsername(formattedRut)
                } else {
                    setUsername(inputValue)
                }
            }
        }
            break
        case 'password':
            setPassword(event.target.value)
            break
        }
    }

    useEffect(() => {
        if (location.pathname.length > 1) {
            /* navigate('/', {replace:true}) */
        }
    }, [])

    const handleSubmit = async (event) => {
        if (event) event.preventDefault()
        const loginState = await login(username, password)

        if (loginState.state) {
            if (loginState.changePasswordRequired) {
                setChangePasswordData({
                    user: loginState.user,
                    passProvisory: loginState.passProvisory,
                    originalPassword: password
                })
                setShowChangePassword(true)
                return
            }

            initiateEndAllShifts(false)
            navigate('/welcome', { replace: true })
        }
    }

    const handlePasswordChanged = async (newPassword) => {
        setShowChangePassword(false)
        setPassword(newPassword)
        // Intentar login de nuevo con la nueva contraseña
        const loginState = await login(username, newPassword)
        if (loginState.state && !loginState.changePasswordRequired) {
            initiateEndAllShifts(false)
            navigate('/welcome', { replace: true })
        }
    }

    const toResetPassword = () => {
        setShowRequestReset(true)
    }

    const handleResetSuccess = ({ rut, tempPassword }) => {
        setUsername(rut)
        setPassword(tempPassword)
    }

    return (
        <Grid container style={{ padding: 10, height: '50%' }} alignItems='center' justifyContent='center'>
            <form onSubmit={handleSubmit}>
                <Grid container item spacing={2}>
                    <Grid item xs={12} container justifyContent='center' style={{ paddingTop: 40 }}>
                        <TextField
                            type='text'
                            name='username'
                            label="rut / email"
                            value={username}
                            onChange={handleChange}
                            variant='outlined'
                            style={{ maxWidth: 400, minWidth: 300, width: '100%' }}
                        />
                    </Grid>
                    <Grid item xs={12} container justifyContent='center' style={{ paddingTop: 40 }}>
                        <TextField
                            type={verPassword}
                            name='password'
                            label={dictionary.login.passwordField}
                            value={password}
                            onChange={handleChange}
                            variant='outlined'
                            style={{ maxWidth: 400, minWidth: 300, width: '100%' }}
                        />
                        <IconButton style={{ width: 0, position: 'relative', right: 25, zIndex: 1, padding: 0 }} onClick={() => { cambiarVistaPassword() }}>
                            {
                                verPassword === 'password' && <FontAwesomeIcon icon={faEye} />
                            }
                            {
                                verPassword === 'text' && <FontAwesomeIcon icon={faEyeSlash} />
                            }
                        </IconButton>
                    </Grid>
                    <Grid item xs={12} container justifyContent='center' style={{ paddingTop: 40 }}>
                        <Button
                            sx={{
                                borderRadius: 20,
                                maxWidth: 400,
                                minWidth: 300,
                                width: '100%',
                                marginBottom: 2
                            }}
                            type='submit' variant='contained' color='primary'>
                            {dictionary.login.loginButton}
                        </Button>
                    </Grid>
                    <Grid item xs={12} container justifyContent='center'>
                        <p className='link-text' onClick={toResetPassword}>{dictionary.login.forgotPasswordText}</p>
                    </Grid>
                </Grid>
            </form>

            {showChangePassword && changePasswordData && (
                <ChangePasswordDialog
                    open={showChangePassword}
                    user={changePasswordData.user}
                    passProvisory={changePasswordData.passProvisory}
                    originalPassword={changePasswordData.originalPassword}
                    onPasswordChanged={handlePasswordChanged}
                    onCancel={() => setShowChangePassword(false)}
                />
            )}

            {showRequestReset && (
                <RequestPasswordResetDialog
                    open={showRequestReset}
                    onClose={() => setShowRequestReset(false)}
                    setstatus={setstatus}
                    onSuccess={handleResetSuccess}
                />
            )}
        </Grid>
    )
}

export default Login
